import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs';

import {
  CoolingTemperatureProgramCommands,
  CoolingTemperatureProgram,
  Feature,
  FeatureNames,
} from '@vi-iot/client';

import { InstallationFeaturesStore } from '@store';

import { HeatingPanelService } from '../heating-panel.service';

@Component({
  selector: 'app-cooling-temperature',
  templateUrl: './cooling-temperature.component.html',
  styleUrls: ['./cooling-temperature.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CoolingTemperatureComponent implements OnInit {
  @Input() circuitId: string;

  reducedCooling$: Observable<
    Feature<CoolingTemperatureProgram, CoolingTemperatureProgramCommands>
  >;
  normalCooling$: Observable<Feature<CoolingTemperatureProgram, CoolingTemperatureProgramCommands>>;
  comfortCooling$: Observable<
    Feature<CoolingTemperatureProgram, CoolingTemperatureProgramCommands>
  >;

  constructor(
    public heatingPanelService: HeatingPanelService,
    private installationFeaturesStore: InstallationFeaturesStore
  ) {}

  ngOnInit(): void {
    this.reducedCooling$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.circuitReducedCooling(this.circuitId)
    );
    this.normalCooling$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.circuitNormalCooling(this.circuitId)
    );
    this.comfortCooling$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.circuitComfortCooling(this.circuitId)
    );
  }
}
